import { Action } from "./action";


export class FileAction extends Action {

    override execute(val: any, row: any, callback: Function): void {
    this.component.getDataService().downloadFile(row.endpoint, val.id).subscribe(response => {
      const blob = new Blob([response.body!], {
        type: response.body?.type || 'application/octet-stream',
      });

      if (blob.type !== "" && callback) {
        callback(blob, val, response.headers);
      }
    });
  }

}
